import { observer } from "mobx-react-lite";
import Layout from "../../components/layout/Layout";
import { useStore } from "../../stores/root-store-context";
import {
  Button,
  Card,
  Descriptions,
  Flex,
  Form,
  Input,
  Modal,
  Image,
  Spin,
  Tag,
  Divider,
  Space,
} from "antd";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import { Employee, HistoryItem } from "../../api/EmployeesApiClient";
import { MobileOutlined, MailOutlined, GiftOutlined } from "@ant-design/icons";
import { Roles } from "../../stores/EmployeesStore";
import { SkillLevelName, SkillLevelNameColor } from "../../helpers/skills";
import { useTranslation } from "react-i18next";
import {
  CalendarOutlined,
  EnvironmentOutlined,
  BookOutlined,
} from "@ant-design/icons";
import InfoBlock from "../../components/blocks/InfoBlock";
import EducationBlock from "../../components/blocks/EducationBlock";
import ReactPDF, { pdf, PDFDownloadLink, PDFViewer } from "@react-pdf/renderer";
import CVGenerator from "./CVGenerator";
import ExperienceBlock from "../../components/blocks/ExperienceBlock";
import dayjs from "dayjs";
import { render } from '@testing-library/react';
import Error404 from './../Error404';
import html2canvas from "html2canvas";
import jsPDF from "jspdf";


const Account = observer(() => {
  const { applicationStore, employeesStore, projectsStore } = useStore();
  const navigate = useNavigate();
  const userPage = useRef(null);
  const { id } = useParams();
  const { t } = useTranslation();

  const [isModalPassword, setIsModalPassword] = useState(false);
  const [isModalEmail, setIsModalEmail] = useState(false);
  const [loading, setLoading] = useState(true);
  const [user, setUser] = useState<Employee>();
  // const [history, setHistory] = useState<HistoryItem[]>([]);

  const showModalPassword = () => {
    setIsModalPassword(true);
  };

  const handleOkPassword = () => {
    setIsModalPassword(false);
  };

  const handleCancelPassword = () => {
    setIsModalPassword(false);
  };

  const showModalEmail = () => {
    setIsModalEmail(true);
  };

  const handleOkEmail = () => {
    setIsModalEmail(false);
  };

  const handleCancelEmail = () => {
    setIsModalEmail(false);
  };
  function ParseToJson(str: string): any[] {
    try {
      return JSON.parse(str);
    } catch (e) {
      return [];
    }
  }
  useEffect(() => {
    if (id) {
      setLoading(true);
      employeesStore.ApiStore.EmployeesApiClient.getUserById(id)
        .then(async (result) => {
          console.log("result");
          console.log(result);
          setUser(result);

          // if(projectsStore.projects?.length === 0){
          //   await projectsStore.getAll()
          // }
          // await employeesStore.ApiStore.EmployeesApiClient.getHistoryByUser(id).then(res => {
          //   setHistory(res)
          // });
        })
        .finally(() => {
          setLoading(false);
        });
    } else {
      navigate("/404");
    }
    // employeesStore.ApiStore.EmployeesApiClient.getUserById(id);
    console.log(id);
  }, [id]);

  return (
    <Layout headerStyle={1} footerStyle={2}>
      <Spin spinning={loading} style={{ minHeight: 600 }}>
        <Flex className="container" gap={10} style={{ marginTop: 20, display: "flex", justifyContent: "space-between" }}>
          <Button
            style={{ float: "left", borderRadius: 0 }}
            onClick={() => {
              navigate(-1);
            }}
          >
            Back
          </Button>
          <Space>
            {user && (
              <PDFDownloadLink
                document={
                  <CVGenerator user={user} skills={applicationStore.skills} />
                }
                fileName="cv.pdf"
              >
                {({ blob, url, loading, error }) =>
                  <Button type="primary">{loading ? "Loading document..." : "Download CV"}</Button>
                }
              </PDFDownloadLink>
            )
            }
            <Button type="primary" onClick={async () => {
              if (userPage.current && user) {
                const element = userPage.current;
                setLoading(true);
                document.querySelectorAll('.fa.fa-pencil').forEach(el => {
                  const element = el as HTMLElement;
                  element.style.display = 'none';
                });
                const canvas = await html2canvas(element, {
                  useCORS: true, // This helps with capturing external images or resources
                  scale: 4, // Increase scale to improve quality
                  logging: false, // Disable console logging for better performance
                  scrollX: -window.scrollX, // Consider scroll positions
                  scrollY: -window.scrollY,
                });

                const imgData = canvas.toDataURL('image/png');

                const pdf = new jsPDF({
                  orientation: 'portrait',
                  unit: 'px',
                  format: [canvas.width, canvas.height], // set needed dimensions for A4 page
                });
                const pdfWidth = pdf.internal.pageSize.getWidth();
                const pdfHeight = (canvas.height * pdfWidth) / canvas.width;

                pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);
                pdf.save(`${user.firstName}_${user.lastName}.pdf`);
                document.querySelectorAll('.fa.fa-pencil').forEach(el => {
                  const element = el as HTMLElement;
                  element.style.display = 'block';

                });
                setLoading(false);
              }
            }}>{"Download CV 2"}</Button>
          </Space>
        </Flex>

        <Flex
          className="container"
          gap={10}
          style={{ marginTop: 20, marginBottom: 20 }}
          ref={userPage}
        >
          {user && (
            <>
              <Flex
                vertical
                align="center"
                style={{
                  flex: "1 1 300px",
                  border: "1px solid #f5f4f4",
                  padding: 10,
                }}
                gap={10}
              >
                <Image
                  width={160}
                  height={160}
                  style={{ borderRadius: "50%", objectFit: "cover" }}
                  src={
                    user?.photoId
                      ? `https://res.cloudinary.com/dnl3x07wo/image/upload/${user?.photoId}`
                      : "https://res.cloudinary.com/dnl3x07wo/image/upload/w_300/z03w7hlsy8hcoic9dlcn"
                  }
                />
                <Tag
                  color="blue"
                  style={{
                    backgroundColor: "lightgray",
                    textAlign: "center",
                  }}
                >
                  <div style={{ fontWeight: "bold" }}>
                    {applicationStore.jobTitles.find(el => el.id === user?.jobTitleId)?.title}
                  </div>
                </Tag>
                <span style={{ fontSize: 24 }}>
                  {`${user?.firstName} ${user?.lastName}`}
                  {(applicationStore.user.id === user?.id ||
                    applicationStore.user.roleId === Roles.Owner ||
                    applicationStore.user.roleId === Roles.Manager) && (
                      <Button
                        title={`${t("user.UpdateProfile")}`}
                        onClick={() => navigate("./edit")}
                        shape="circle"
                        type="text"
                      >
                        <i
                          className="fa fa-pencil"
                          style={{ fontSize: 20, color: "gray" }}
                          aria-hidden="true"
                        ></i>
                      </Button>
                    )}
                </span>
                {/* <Tag color="gray">{Roles[user.roleId]}</Tag> */}
                <a href={`mailto:${user?.email}`}>
                  <MailOutlined />
                  {` ${user?.email}`}
                </a>
                {user?.phoneNumber && (
                  <a href={`mailto:${user?.phoneNumber}`}>
                    <MobileOutlined />
                    {` ${user?.phoneNumber}`}
                  </a>
                )}
                <div>{`${dayjs(user?.birthDay)?.format("DD MMMM")} `}<GiftOutlined /></div>
                <h6>{`${t("user.MySkills")}`}</h6>
                <Flex style={{ maxWidth: 300 }} wrap gap={10} justify="center">
                  {user?.userSkills?.map((el, index) => {
                    return (
                      <Tag
                        key={index}
                        color="blue"
                        style={{
                          backgroundColor:
                            SkillLevelNameColor[parseInt(el.skillLevel)],
                          textAlign: "center",
                        }}
                      >
                        <div style={{ fontWeight: "bold" }}>
                          {el.skill.title}
                        </div>
                        <div>{SkillLevelName[parseInt(el.skillLevel)]}</div>
                        <div style={{ fontWeight: "bold" }}>
                          {el.experienceYears} {t("years")}
                        </div>
                      </Tag>
                    );
                  })}
                </Flex>
                <h6>{`${t("user.MyProjects")}`}</h6>
                <Flex style={{ maxWidth: 200 }} gap={10} vertical>
                  {user?.userProjects?.map((el) => {
                    return (
                      <div>
                        <Link
                          to={`/${applicationStore.company.Tenaut}/projects/${el.project.id}`}
                          style={{ color: "blue", textDecoration: "underline" }}
                        >
                          {el.project.title}
                        </Link>
                      </div>
                    );
                  })}
                </Flex>
              </Flex>
              <Flex
                style={{
                  flex: "1 1 600px",
                  // border: "1px solid #f5f4f4",
                  // padding: 20,
                }}
                vertical
              >
                <InfoBlock
                  title={`${t("user.AboutMe")}`}
                  onEdit={() => {
                    navigate("./edit");
                  }}
                >
                  <p style={{ marginBottom: 20 }}>{user?.aboutMe}</p>
                </InfoBlock>
                <InfoBlock
                  title={`${t("user.MyHobby")}`}
                  onEdit={() => {
                    navigate("./edit");
                  }}
                >
                  <p style={{ marginBottom: 20 }}>{user?.hobby}</p>
                </InfoBlock>
                <EducationBlock
                  educationList={ParseToJson(user.education)}
                  removeEducation={async () => { }}
                  canRemove={false}
                ></EducationBlock>
                <ExperienceBlock experienceList={ParseToJson(user.experience)}
                  removeExperience={async () => { }}
                  canRemove={false}
                ></ExperienceBlock>
              </Flex>
            </>
          )}
        </Flex>
      </Spin>
      <Modal
        title="Enter new email"
        open={isModalEmail}
        onOk={handleOkEmail}
        onCancel={handleCancelEmail}
      >
        <Form>
          <Form.Item<any>
            name="Email"
            style={{ width: "100%" }}
            rules={[{ required: true }]}
          >
            <Input placeholder="Email" pattern="^[^@\s]+@[^@\s]+\.[^@\s]+$" />
          </Form.Item>
        </Form>
      </Modal>

      <Modal
        title="Enter new Password"
        open={isModalPassword}
        onOk={handleOkPassword}
        onCancel={handleCancelPassword}
      >
        <Form>
          <Form.Item<any>
            name="Password"
            style={{ width: "100%" }}
            rules={[{ required: true }]}
          >
            <Input placeholder="Password" type="password" />
          </Form.Item>
        </Form>
      </Modal>
    </Layout>
  );
});
export default Account;
